@if (!ticket.unavailable && !ticket.requiresReasonKeys?.length && displayCheck) {
  <section (mouseleave)="tt1.close()" class="container">
    <img
      src="{{ resultItemType.check }}"
      alt="Green check - Can book"
      class="error_icon"
      id="green-error-icon-{{ iconId }}"
      triggers="manual"
      #tt1="ngbTooltip"
      ngbTooltip="Can Book"
      i18n-ngbTooltip
      (mouseenter)="tt1.open()"
      i18n-alt
      attr.aria-label="Can Book"
      (focus)="tt1.open()"
      (blur)="tt1.close()"
      tabindex="0"
    /><span class="visuallyhidden">Can book</span>
  </section>
}

@if (ticket.unavailable) {
  <section (mouseleave)="tt2.close()" class="container">
    <img
      class="error_icon"
      id="red-error-icon-{{ iconId }}"
      src="{{ resultItemType.minus }}"
      triggers="manual"
      #tt2="ngbTooltip"
      (mouseenter)="tt2.open()"
      alt="Red warning - Cannot book"
      i18n-alt
      ngbTooltip="{{ ticket.unavailableMessage }}"
      attr.aria-label="{{ ticket.unavailableMessage }}"
      (focus)="tt2.open()"
      (blur)="tt2.close()"
      tabindex="0"
    /><span class="visuallyhidden">{{ ticket.unavailableMessage }}</span>
  </section>
}
@if (ticket.requiresReasonKeys?.length && !isUnavailableOnly && !ticket.unavailable) {
  <section (mouseleave)="tt3.close()" class="container">
    <img
      class="error_icon"
      id="amber-error-icon-{{ iconId }}"
      src="{{ resultItemType.exclamation }}"
      triggers="manual"
      #tt3="ngbTooltip"
      (mouseenter)="tt3.open()"
      alt="Amber Warning - Requires Reason"
      i18n-alt
      ngbTooltip="{{ messages }}"
      attr.aria-label="{{ messages }}"
      (focus)="tt3.open()"
      (blur)="tt3.close()"
      tabindex="0"
    /><span class="visuallyhidden">{{ messages }}</span>
  </section>
}
